import styled from 'styled-components';
import { Button } from '~/components/ui/Button';
import { Text } from '../Text';

const StyledContainer = styled.div`
	position: absolute;
	top: 160px;
	right: 80px;
	width: 340px;
	padding: 27px 30px 30px;
	background-color: rgba(17, 19, 20, 0.98);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	opacity: 0;
	transition: opacity 0.3s ease;

	&.shop-preview-enter {
		opacity: 0;
	}

	&.shop-preview-enter-active,
	&.shop-preview-enter-done,
	&.shop-preview-exit {
		opacity: 1;
	}

	&.shop-preview-exit-active {
		opacity: 0;
	}
`;

const StyledPriceContainer = styled.div<{
	$oldPrice?: boolean;
	$hide?: boolean;
}>`
	display: ${({ $hide }) => ($hide ? 'none' : 'grid')};
	grid-template-columns: ${({ $oldPrice }) =>
		$oldPrice ? '1fr auto auto 16px' : '1fr auto 16px'};
	gap: 6px;
	margin-top: 20px;
	align-items: center;
`;

const StyledButtonsContainer = styled.div<{ $hide?: boolean }>`
	display: ${({ $hide }) => ($hide ? 'none' : 'grid')};
	grid-template-columns: 1fr 1fr;
	gap: 10px;
`;

const StyledRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;
`;

const StyledStockRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;

	${Text} {
		font-size: 16px;
		color: #ffffff;
	}
`;

const StyledButton = styled(Button)<{ $isLastOdd?: boolean }>`
	${({ $isLastOdd }) => $isLastOdd && 'grid-column: span 2;'}
`;

const StyledButtonContent = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;

	img {
		height: 16px;
		width: 16px;
		user-select: none;
		pointer-events: none;
	}
`;

const StyledVariantsRow = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin-top: 20px;

	& > ${Text} {
		font-size: 16px;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledVariantsContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 1px;
`;

const StyledButtonContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	cursor: pointer;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	transition: background-color 0.3s ease;

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}

	img {
		width: 10px;
		height: 10px;
		user-select: none;
		pointer-events: none;
		transition:
			filter 0.3s ease,
			opacity 0.3s ease;
	}
`;

const StyledVariants = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 50px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.02);
	border: 1px solid rgba(255, 255, 255, 0.05);

	${Text} {
		font-weight: 400;
		font-size: 12px;
		color: rgba(255, 255, 255, 0.5);

		span {
			font-weight: 500;
			font-size: 14px;
			color: #ffffff;
		}
	}
`;

const StyledName = styled(Text)`
	font-size: 16px;
	font-weight: 500;
	color: #ffffff;

	span {
		opacity: 0.5;
	}
`;

const StyledOldPriceContainer = styled.div`
	position: relative;
	display: flex;
	align-items: center;
	gap: 6px;
	margin-right: 4px;
	opacity: 0.25;

	img {
		opacity: 0.5;
	}

	${Text} {
		font-weight: 700;
		font-size: 14px;
		color: #ffffff;
	}

	.line {
		position: absolute;
		top: 50%;
		left: -3px;
		transform: translateY(-50%);
		width: calc(100% + 6px);
		height: 1px;
		background-color: #ffffff;
		transition: background-color 0.3s ease;
	}
`;

export {
	StyledButton,
	StyledButtonContainer,
	StyledButtonContent,
	StyledButtonsContainer,
	StyledContainer,
	StyledName,
	StyledOldPriceContainer,
	StyledPriceContainer,
	StyledRow,
	StyledStockRow,
	StyledVariants,
	StyledVariantsContainer,
	StyledVariantsRow,
};
